import axios from "axios";
const isProd = window.location.hostname === "seller.gostor.com";
let hostApi;
if (isProd) hostApi = "https://search-service.arzoopro.com/";
else hostApi = "https://search-service.dev.arzoopro.com/";

export const getData = async (retailer_id) => {
  try {
    const response = await axios.post(
      `${hostApi}sellerDashboardSummary/sales`,
      {
        retailer_id: retailer_id,
      }
    );
    return response?.data;
  } catch (error) {
    console.log("Error", error);
  }
};
